import { statisticsApi as statisticsApiUrl } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';

export const statisticsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSales: builder.query({
      query: ({ startDate, endDate }) => ({
        url: statisticsApiUrl(),
        method: 'POST',
        body: { 
          data: {
            endDate,
            startDate
          },
          method: 'sales'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { startDate, endDate }) => [
        { type: 'Sales', id: `${startDate}-${endDate}` },
        { type: 'Statistics', id: 'sales' }
      ],
    }),
    fetchAnalytics: builder.query({
      query: ({ startDate, endDate }) => ({
        url: statisticsApiUrl(),
        method: 'POST',
        body: {
          data: {
            dimensions: 'ga:pagePath',
            fetchStore: true,
            metrics: 'ga:sessions, ga:averageSessionDuration',
            sort: '-ga:sessions',
            startDate,
            endDate,
          },
          method: 'queryAnalytics'
        },
        // Suppress error toast for analytics - it's supplementary data
        suppressGenericErrorToast: true,
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { startDate, endDate }) => [
        { type: 'Analytics', id: `${startDate}-${endDate}` },
        { type: 'Statistics', id: 'analytics' }
      ],
    }),
    fetchBrokendownAnalytics: builder.query({
      query: ({ startDate, endDate, filters, dimensions, metrics, sort, courseId }) => ({
        url: statisticsApiUrl(),
        method: 'POST',
        body: {
          data: {
            dimensions: dimensions,
            courseId,
            metrics: metrics,
            filters: filters && 'ga:pagePath=@' + filters,
            sort: sort,
            startDate,
            endDate,
          },
          method: 'queryAnalytics'
        },
        // Suppress error toast for analytics - it's supplementary data
        suppressGenericErrorToast: true,
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { startDate, endDate, courseId }) => [
        { type: 'Analytics', id: `${startDate}-${endDate}-${courseId || 'all'}` },
        { type: 'Statistics', id: 'analytics' }
      ],
    }),
    fetchInvitationStats: builder.query({
      query: ({ startDate, endDate }) => ({
        url: statisticsApiUrl(),
        method: 'POST',
        body: {
          data: {
            startDate,
            endDate,
          },
          method: 'invitations'
        },
      }),
      transformResponse: (response) => response.data,
      providesTags: (result, error, { startDate, endDate }) => [
        { type: 'Invitations', id: `${startDate}-${endDate}` },
        { type: 'Statistics', id: 'invitations' }
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useFetchSalesQuery,
  useFetchAnalyticsQuery,
  useFetchBrokendownAnalyticsQuery,
  useFetchInvitationStatsQuery,
} = statisticsApiSlice;